"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _sideNav = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/side-nav.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _sideNav.default);

var SideNavList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SideNavList, _React$Component);

  var _super = _createSuper(SideNavList);

  function SideNavList(props) {
    (0, _classCallCheck2.default)(this, SideNavList);
    return _super.call(this, props);
  }

  (0, _createClass2.default)(SideNavList, [{
    key: "render",
    value: function render() {
      var _context;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          hasParent = _this$props.hasParent,
          onItemSelect = _this$props.onItemSelect,
          open = _this$props.open,
          selectedId = _this$props.selectedId,
          title = _this$props.title,
          titleProps = _this$props.titleProps,
          isUtility = _this$props.isUtility,
          level = _this$props.level,
          condensed = _this$props.condensed,
          compact = _this$props.compact,
          groupLabel = _this$props.groupLabel,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "hasParent", "onItemSelect", "open", "selectedId", "title", "titleProps", "isUtility", "level", "condensed", "compact", "groupLabel"]);
      var sideNavListClasses = classnames({
        'fd-nested-list--text-only': !condensed,
        'fd-nested-list--compact': compact
      }, 'fd-nested-list', "level-".concat(level), className);
      var sideNavContainerClass = classnames({
        'fd-side-nav__main-navigation': !isUtility,
        'fd-side-nav__utility': isUtility
      });

      var sideNavList = /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({}, rest, {
        "aria-expanded": hasParent && open,
        "aria-hidden": hasParent && !open,
        "aria-label": groupLabel,
        className: sideNavListClasses
      }), title && /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, titleProps, {
        className: classnames('fd-nested-list__group-header')
      }), title), (0, _map.default)(_context = _react.default.Children.toArray(children)).call(_context, function (child) {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          condensed: condensed,
          isSubItem: hasParent,
          onItemSelect: onItemSelect,
          selected: selectedId === child.props.id,
          selectedId: selectedId
        });
      }));

      var sideNav = hasParent ? sideNavList : /*#__PURE__*/_react.default.createElement("nav", {
        className: sideNavContainerClass
      }, sideNavList);
      return sideNav;
    }
  }]);
  return SideNavList;
}(_react.default.Component);

process.env.NODE_ENV !== "production" ? SideNavList.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Internal use only */
  compact: _propTypes.default.bool,

  /** Internal use only */
  condensed: _propTypes.default.bool,

  /** Localized label for menu group if title not included */
  groupLabel: _propTypes.default.string,

  /** Internal use only */
  hasParent: _propTypes.default.bool,

  /** Display a separate utility menu separated from the main menu by a horizontal line */
  isUtility: _propTypes.default.bool,

  /** Depth of menu. Default prop is 1 and does not need to be passed to the top level menu.
   * Increase by 1 for every submenu and provide as a prop */
  level: _propTypes.default.number,

  /** Internal use only */
  open: _propTypes.default.bool,

  /** Internal use only */
  selectedId: _propTypes.default.string,

  /** Localized text for the heading */
  title: _propTypes.default.string,

  /**Additional props to be spread to the title\'s heading element */
  titleProps: _propTypes.default.object,

  /** Internal use only */
  onItemSelect: _propTypes.default.func
} : void 0;
SideNavList.defaultProps = {
  level: 1
};
SideNavList.displayName = 'SideNav.List';

var _default = (0, _withStyles.default)(SideNavList);

exports.default = _default;